module.exports = __webpack_public_path__ + "img/1996.028fe387.png";